<script setup lang="ts">
import useUserStore from "~/stores/user";

const { t } = useI18n();
const userStore = useUserStore();
const appConfig = useRuntimeConfig().public;
const isLeagueView = appConfig.APP_CUSTOMER.enable_leagues_view;
</script>

<template>
  <ListEvents
    v-if="userStore.isAuthenticated"
    :title="t('labels.following')"
    class="main-container text-2xl text-main"
    recommended
    has-see-all-link
  >
    <template #end>
      <div class="hr mt-10" role="separator" />
    </template>
    <template #empty>
      <i18n-t
        tag="div"
        class="text-secondary text-base"
        keypath="pages.categories.no_following_category_for_logged_user"
      >
        <template #here>
          <BaseButton
            class="mx-1 lowercase underline"
            tag="nuxt-link" :to="isLeagueView ? '/following/league' : '/following/category'"
            link
            type="secondary"
            :title="t('labels.here')"
            :name="t('labels.here')"
          >
            {{ t('labels.here') }}
          </BaseButton>
        </template>
      </i18n-t>
    </template>
  </ListEvents>
  <div v-else class="main-container">
    <h1 class="font-bold text-2xl text-main">
      {{ t('labels.following') }}
    </h1>
    <div class="flex items-center mt-6 gap-4">
      <IconCard />
      <i18n-t tag="p" keypath="pages.categories.no_following_category_for_unlogged_user" class="text-secondary text-base">
        <template #login>
          <AuthButton
            class="mx-1 lowercase underline"
            mode="sign-in"
            link
            type="secondary"
            :title="t('labels.sign_in')"
          />
        </template>
      </i18n-t>
    </div>
    <div class="hr mt-10" role="separator" />
  </div>
</template>
